import { ChatBubble } from '@eriko/ui/src/components/ui/chat';
import type { ChatMessage } from '../../../stores/chatStore';

interface SystemMessageProps {
  msg: ChatMessage;
}

export function SystemMessage({ msg }: SystemMessageProps) {
  return (
    <div className="flex justify-center animate-[fade-up_0.25s_ease-out]">
      <ChatBubble variant="system">{msg.content}</ChatBubble>
    </div>
  );
}
